import { render, staticRenderFns } from "./GoodDetail.vue?vue&type=template&id=9d315db8&scoped=true&"
import script from "./GoodDetail.vue?vue&type=script&lang=js&"
export * from "./GoodDetail.vue?vue&type=script&lang=js&"
import style0 from "./GoodDetail.vue?vue&type=style&index=0&id=9d315db8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d315db8",
  null
  
)

export default component.exports